import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { UrlConfigContainer } from '../../../core/url-config';
import { StoreItemModel } from '../models/store-item-model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigService } from '@hrra/core';

@Injectable()
export class StoreService {
  public listStockItems(
    productType: number
  ): Observable<PagingWrapper<StoreItemModel>> {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.store.items.list,
      { onlyActive: true, productType: productType },
      StoreItemModel
    );
  }

  public listEventRelatedStockItems(
    productType: number,
    eventId: number
  ): Observable<PagingWrapper<StoreItemModel>> {
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.store.items.listEventSpecific,
      { productTypeId: productType, eventId: eventId },
      StoreItemModel
    );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
